import React from 'react'
import { smallSpacing } from '../enums/Spacings'
import Box from './Box'

export const TableBox = (props) => <Box {...props} pointer fullWidth fullPadding spacing={smallSpacing} />
